import { EXECUTE_POLICY_TRANSACTION_CUSTOM_ACTION } from '../../constants/actions/policy';

export function executePolicyTransactionCustomAction(payload) {
    return {
        type: EXECUTE_POLICY_TRANSACTION_CUSTOM_ACTION,
        payload,
    };
}
